<template>
    <div class="notifications-container">
        <el-card v-for="(note, index) in notifications" :key="index" class="notification-card" shadow="hover"
            v-if="notifications.length > 0">
            <div class="notification-header">
                <h4 class="notification-title">{{ note.type_display }}</h4>
                <span class="notification-date">{{ formatDate(note.created_at) }}</span>
            </div>
            <p class="notification-text">{{ note.message }}</p>
        </el-card>

        <div class="empty-state" v-if="notifications.length === 0">
            <p class="empty-text">{{ $t('no_notifications') }}</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'NotificationsPage',
    components: {
    },
    data() {
        return {
            notifications: []
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            let headers = { Authorization: "Token " + sessionStorage.getItem("key") };
            axios
                .get("notifications/", { headers })
                .then((r) => {
                    console.log(r);
                    this.notifications = r.data;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        formatDate(dateStr) {
            if (!dateStr) return '';

            const date = new Date(dateStr);

            if (isNaN(date.getTime())) return dateStr;

            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');

            return `${day}.${month}.${year}, ${hours}:${minutes}`;
        }
    },
};
</script>

<style scoped>
.notifications-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.notification-card {
    padding: 16px;
    border-radius: 10px;
    transition: box-shadow 0.3s ease;
}

.notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.notification-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.notification-date {
    font-size: 12px;
    color: #999;
    white-space: nowrap;
}

.notification-text {
    font-size: 14px;
    color: #606266;
    margin: 0;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    color: #909399;
    text-align: center;
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    color: #c0c4cc;
}

.empty-text {
    font-size: 16px;
    margin: 0;
}
</style>